<template>
    <div>
        <span class="fs-14 pl-1 fw-700">Поставщик подтвердил соответствие требованиям п.1 ч.1 ст.31, прикрепив следующие документы:</span>
        <b-table id="my-table" :fields="fields" :items="documents" class="table-atmo mb-0" thead-class="d-none" show-empty small responsive>
            <template #cell(index)="data">
                {{ data.index + 1 }}. {{ data.item.document_name }} - <a class="fs-14 col-form-label d-inline-block" style="color: var(--green-color) !important" :href="$getAttachmentDownloadLink(data.item.stored_document.id)" target="_blank">{{ data.item.stored_document.name }}</a>
            </template>
            <template #cell(name)="data">
                {{ data.item.document_name }}
            </template>
            <template #cell(document)="data">
                <a class="fs-14 col-form-label d-inline-block" style="color: var(--green-color) !important" :href="$getAttachmentDownloadLink(data.item.stored_document.id)" target="_blank">{{ data.item.stored_document.name }}</a>
            </template>
        </b-table>
    </div>
</template>

<script>

export default {
    name: 'supplier-requirement-supplier-reqs-a-view-table',
    props: {
        documents: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            fields: [
                { key: 'index', label: '№', tdClass: 'align-text-top text-nowrap py-0 pr-0 border-0 td-width-1', thClass: 'py-0' },
                //{ key: 'name', label: 'Описание документа', tdClass: 'align-text-top py-0 pr-0 border-0  td-width-1', thClass: 'py-0' },
                //{ key: 'document', label: 'Документ', tdClass: 'align-text-top py-0 pr-0 border-0 text-nowrap td-width-1', thClass: 'py-0' },
            ]
        };
    }
};
</script>
<style>
    .td-width-1 {
        width: 1px;
    }
</style>
